import calculateSplat from './calculateSplat';

const calculateSplatForBrush = (pressure, pressureCoefficient, properties, settings) => {
  let splatProperties;

  if (settings.useAsPencil) {
    splatProperties = calculateSplat(pressure, pressureCoefficient, properties, settings.secondary);
  } else {
    splatProperties = calculateSplat(pressure, pressureCoefficient, properties, settings.primary);
  }

  return splatProperties;
};

export default calculateSplatForBrush;
